function productSwiper() {
  const containers = document.querySelectorAll('.c-product-slider-container');

  containers.forEach(function (container) {
    const swiperEl = container.querySelector('.c-product-slider');
    const paginationEl = container.querySelector('.swiper-pagination');
    const nextEl = container.querySelector('.c-product-slider-next');
    const prevEl = container.querySelector('.c-product-slider-prev');

    if (!swiperEl) return;

    const inLottery = !!container.closest('.c-product-lottery');
    const lotterySlideCount = inLottery
      ? swiperEl.querySelectorAll('.swiper-slide').length
      : 0;
    const lotterySingleLayout = inLottery && lotterySlideCount <= 1;
    const desktopBreakpoints = lotterySingleLayout
      ? {
          768: {
            centeredSlides: false,
            slidesPerView: 1,
            spaceBetween: 40,
          },
          992: {
            centeredSlides: false,
            slidesPerView: 1,
            spaceBetween: 53,
          },
        }
      : {
          768: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 20,
          },
          992: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 30,
          },
        };

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.4,
      centeredSlides: true,
      spaceBetween: 12,

      pagination: {
        el: paginationEl,
        clickable: true,
      },

      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },

      breakpoints: desktopBreakpoints,

      on: {
        init: toggleNavVisibility,
        breakpoint: toggleNavVisibility,
      },
    });

    function toggleNavVisibility(swiper) {
      if (!nextEl || !prevEl) return;
      const totalSlides = swiper.slides.length;
      const perView = Math.floor(swiper.params.slidesPerView);
      const shouldHide = totalSlides <= perView;

      nextEl.style.display = shouldHide ? 'none' : '';
      prevEl.style.display = shouldHide ? 'none' : '';
    }

  });
}

document.addEventListener("DOMContentLoaded", () => {
  productSwiper();
});


function initAuctionCountdowns() {
  var deadlines = document.querySelectorAll('[data-auction-end]');
  if (!deadlines.length) return;

  function updateCountdown(el) {
    var end = new Date(el.dataset.auctionEnd).getTime();
    if (isNaN(end)) return false;

    var now = Date.now();
    var diff = end - now;

    if (diff <= 0) {
      el.textContent = '終了しました';
      el.classList.add('c-countdown--ended');
      var card = el.closest('.c-product-list__item');
      if (card) {
        var cta = card.querySelector('.c-secondary-btn');
        if (cta) {
          cta.textContent = '詳細を見る';
          cta.classList.add('c-secondary-btn--detail');
        }
      }
      return false;
    }

    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    el.querySelector('[data-days]').textContent = String(d).padStart(2, '0');
    el.querySelector('[data-hours]').textContent = String(h).padStart(2, '0');
    el.querySelector('[data-minutes]').textContent = String(m).padStart(2, '0');
    el.querySelector('[data-seconds]').textContent = String(s).padStart(2, '0');
    return true;
  }

  deadlines.forEach(function (el) { updateCountdown(el); });
  setInterval(function () {
    deadlines.forEach(function (el) { updateCountdown(el); });
  }, 1000);
}
initAuctionCountdowns();

if (!customElements.get('product-description-read-more')) {
  customElements.define('product-description-read-more', class extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.product-detail-read-more');
      this.content = this.querySelector('.product-detail-sub-content');
    }

    connectedCallback() {
      if (this.button && this.content) {
        requestAnimationFrame(() => {
          if (this.content.scrollHeight <= this.content.clientHeight) {
            this.button.style.display = 'none';
          }
        });

        this.button.addEventListener('click', () => {
          this.content.classList.toggle('is-expanded');
          if (this.content.classList.contains('is-expanded')) {
            this.button.textContent = '閉じる';
          } else {
            this.button.textContent = 'もっと見る';
          }
        });
      }
    }
  });
}